import script from "./WaitingListAdvise.vue?vue&type=script&setup=true&lang=js"
export * from "./WaitingListAdvise.vue?vue&type=script&setup=true&lang=js"

import "./WaitingListAdvise.vue?vue&type=style&index=0&id=6b8598d2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b8598d2"]])

export default __exports__